import React, { createContext, useState, useEffect } from 'react';

// Create a context
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  // Check for token in localStorage on app load
  useEffect(() => {
    // Check if the token exists in localStorage on app load
    const token = localStorage.getItem('token');
    if (token) {
      const name = localStorage.getItem('name');
      const email = localStorage.getItem('email');
      setIsAuthenticated(true);
      setUser({ name, email });
    } 
    setLoading(false); // Set loading to false after checking localStorage
  }, []);

  // Login function to save token and update auth status
  const login = (user_id, token, name, email, companyname, address1, address2, city, zipCode, phone) => {
    localStorage.setItem('user_id', user_id);
    localStorage.setItem('token', token);
    localStorage.setItem('name', name);  // Store name
    localStorage.setItem('email', email);  // Store email
    localStorage.setItem('companyname', companyname);
    localStorage.setItem('address1', address1);  // Store Address1
    localStorage.setItem('address2', address2);  // Store Address2
    localStorage.setItem('city', city);  // Store City
    localStorage.setItem('zipcode', zipCode);  // Store Zipcode
    localStorage.setItem('companyphone', phone);  // Store Company
    setIsAuthenticated(true);
    setUser({ name, email });
  };

  // Logout function to clear token and update auth status
  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    localStorage.removeItem('email');
    localStorage.removeItem('user_id');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
